import { useLanguage } from '../../common/selectors';
import { I18N } from '../../internationalization/AppText';
import { VideoInfoList, VideoPlaylist } from '../../reducers/resourcesReducer';
import { EditButton } from '../edit/EditButton';
import { MoveButton } from '../edit/MoveButton';
import { VideoCard } from './VideoCard';
import * as CardStyles from './VideoCard.styles';
import * as Styles from './VideoSection.styles';

type SectionType = VideoPlaylist['translations'][0]['data']['sections'][0];
interface VideoSectionProps {
  section: SectionType;
  filterByFavorites?: boolean;
  favorites?: string[];
  length: number;
  fieldKey: string;
  currentPosition: number;
}

export function VideoSection({ section, favorites, filterByFavorites, length, fieldKey, currentPosition }: VideoSectionProps) {
  const isFirst = currentPosition === 0;
  const isLast = currentPosition === length - 1;

  const language = useLanguage();
  const filterVideoList = (videoList: SectionType['videoList']) => {
    if (!filterByFavorites) return videoList;
    return videoList.filter((v) => (favorites || []).indexOf(v.video._id) !== -1);
  };

  const renderVideoCard = (v: VideoInfoList[number]) => {
    if (!v.video) return null;

    return <VideoCard videoInfo={v} language={language} favorites={favorites} isList={isList} isAutoPlay={v.autoPlay} />;
  };

  const renderStep = (v: VideoInfoList[number], idx: number) => (
    <Styles.StepContentWrapper $isFirstStep={idx === 0}>
      <Styles.TextWrapper>
        <Styles.TextHeader>{v.name}</Styles.TextHeader>
        <Styles.TextDescription>{v.description}</Styles.TextDescription>
      </Styles.TextWrapper>
      <Styles.MediaWrapper>{renderVideoCard(v)}</Styles.MediaWrapper>
    </Styles.StepContentWrapper>
  );
  const videoList = filterVideoList(section.videoList || []);
  const isList = section?.sectionType === 'list';
  const isSectionEmpty = videoList.length === 0;

  return (
    <Styles.SectionWrapper>
      {!isList ? (
        <Styles.SectionTitleWrapper>
          <Styles.SectionTitle>
            <span>{section.sectionName}</span>
          </Styles.SectionTitle>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {!isFirst && <MoveButton direction="up" currentIndex={currentPosition} contentType={fieldKey} />}
            {!isLast && <MoveButton direction="down" currentIndex={currentPosition} contentType={fieldKey} />}
            <EditButton currentIndex={currentPosition} contentType={fieldKey} />
          </div>
        </Styles.SectionTitleWrapper>
      ) : null}
      <Styles.FlexWrapper $isList={isList}>
        {videoList.map((v, idx) =>
          isList ? (
            <Styles.StepWrapper key={idx}>{renderStep(v, idx)}</Styles.StepWrapper>
          ) : (
            <CardStyles.CardWrapper key={v.name + idx} $isList={isList}>
              {renderVideoCard(v)}
            </CardStyles.CardWrapper>
          ),
        )}
        {isSectionEmpty && !isList ? (
          <p>
            <I18N text="no_videos_in_category" />
          </p>
        ) : null}
      </Styles.FlexWrapper>
    </Styles.SectionWrapper>
  );
}
